import { Component } from "@angular/core";

@Component({
    selector: "app-about",
    templateUrl: "./about.component.html",
    styleUrls: ["./about.component.css"]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AboutComponent {}



// WEBPACK FOOTER //
// ./src/app/about/about.component.ts